export default function YoutubeIcon() {
    return (<svg width="25" height="17" viewBox="0 0 25 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.041 0C23.2339 0.000116477 25.001 1.93969 25.001 4.3252V12.0635C25.0099 14.4587 23.2339 16.3886 21.041 16.3887H4.65137C2.45839 16.3887 0.691406 14.4491 0.691406 12.0635V4.3252C0.691406 1.92992 2.46727 0 4.65137 0H21.041ZM10.25 12.0498L17.1445 8.07324L10.25 4.09766V12.0498Z" fill="#F5F5F5" />
    </svg>
    )
}